import { useTranslation } from 'react-i18next'

import { useBreadcrumbs } from '../../layout/breadcrumbsContext/useBreadcrumbs/useBreadcrumbs'

const PRODUCTBOARD_PORTAL_URL = 'https://portal.productboard.com/wcddm6aztpepyp3sum7zluw9?hide_logo=1&hide_header=1'

export function ProductRoadmapPage() {
  const { t } = useTranslation()

  useBreadcrumbs([
    {
      label: t('breadcrumb.productRoadmap')
    }
  ])

  return (
    <iframe
      title={t('menu.workplaceGivingSubmenu.productRoadmap')}
      src={PRODUCTBOARD_PORTAL_URL}
      style={{ border: 'none', width: '100%', height: 'calc(100vh - 140px)' }}
    />
  )
}
